<ng-container *ngIf="access?.state !== State.ALLOWED">
  <ng-container *ngTemplateOutlet="prefix"></ng-container>
</ng-container>

<ng-container [ngSwitch]="access?.state">
  <ng-container *ngSwitchCase="State.DISABLED">
    <image-text image="assets/images/icons/state-disabled.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.DISABLED">This feature is currently disabled</p>
      <a class="btn btn-primary" routerLink="/support" i18n="@userAccess.action.contactSupport">Contact Support</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchCase="State.TEMPORARILY_DISABLED">
    <image-text image="assets/images/icons/state-disabled.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.TEMPORARILY_DISABLED">This feature is currently temporarily disabled</p>
      <a class="btn btn-primary" routerLink="/support" i18n="@userAccess.action.contactSupport">Contact Support</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchCase="State.NOT_ALLOWED">
    <image-text image="assets/images/icons/state-unavailable.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.NOT_ALLOWED">This feature is currently not allowed</p>
      <a class="btn btn-primary" routerLink="/support" i18n="@userAccess.action.contactSupport">Contact Support</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchCase="State.TEMPORARILY_NOT_ALLOWED">
    <image-text image="assets/images/icons/state-unavailable.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.TEMPORARILY_NOT_ALLOWED">This feature is currently temporarily not allowed</p>
      <a class="btn btn-primary" routerLink="/support" i18n="@userAccess.action.contactSupport">Contact Support</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchCase="State.REQUIRED_T1">
    <image-text image="assets/images/icons/state-disabled.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.REQUIRED_T1">You need to verify your account first</p>
      <a class="btn btn-primary" routerLink="/verification" i18n="@userAccess.action.verifyAccount">Verify Account</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchCase="State.REQUIRED_T2">
    <image-text image="assets/images/icons/state-disabled.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.REQUIRED_T2">You need to LEVEL 2 verify your account first</p>
      <a class="btn btn-primary" routerLink="/verification" i18n="@userAccess.action.verifyAccount">Verify Account</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchCase="State.REQUIRED_T3">
    <image-text image="assets/images/icons/state-disabled.svg" class="full">
      <p *ngIf="access.reason">{{access.reason}}</p>
      <p *ngIf="!access.reason" i18n="@userAccess.text.REQUIRED_T3">You need to LEVEL 3 verify your account first</p>
      <a class="btn btn-primary" routerLink="/verification" i18n="@userAccess.action.verifyAccount">Verify Account</a>
    </image-text>
  </ng-container>
  <ng-container *ngSwitchDefault="">
    <ng-content></ng-content>
  </ng-container>
</ng-container>

<ng-container *ngIf="access?.state !== State.ALLOWED">
  <ng-container *ngTemplateOutlet="suffix"></ng-container>
</ng-container>
